import { Controller } from "react-hook-form";
import { DatePicker } from "@/components";
import { FormErrorLabel } from "../FormErrorLabel";
import { FormLabel } from "../FormLabel";
import { BadgeInfo } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../ui";

const FormDatePicker = ({
  name,
  label,
  control,
  error,
  isRequired,
  onChange,
  info,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label}{" "}
          {rest?.disabled ? (
            <></>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
          {info && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="mx-1" type="button">
                  <BadgeInfo className="h-3 w-3 stroke-yellow-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{info}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            date={field.value}
            setDate={(date: any) => {
              field.onChange(date);
              onChange && onChange(date);
            }}
            {...field}
            {...rest}
          />
        )}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};
export default FormDatePicker;
